import React from 'react';
import { Gift } from 'lucide-react';
export function BonusesSection() {
  const bonuses = [{
    title: 'KIT DE INICIO RÁPIDO 7 DÍAS',
    desc: 'Empezá hoy sin abrumarte y sentí tus primeras victorias en 7 días.',
    value: '$8.000'
  }, {
    title: 'LISTA MAESTRA DE COMPRAS ANTI-INFLAMACIÓN',
    desc: 'Entrá al súper con un plan claro y salí con todo lo que necesitás.',
    value: '$8.000'
  }, {
    title: 'GUÍA EXPRESS PARA SOBREVIVIR EVENTOS',
    desc: 'Disfrutá asados, cumpleaños y salidas sin arruinar tu progreso.',
    value: '$9.000'
  }, {
    title: 'MENÚS RESUELTOS DE 10 MINUTOS',
    desc: 'Comé bien aunque tu día explote y no tengas tiempo para cocinar.',
    value: '$8.000'
  }, {
    title: 'CHECKLIST DE SEÑALES DE PROGRESO',
    desc: 'Dejá de frustrarte con el número y empezá a ver el progreso real más allá de la balanza.',
    value: '$9.000'
  }, {
    title: 'PLAN DE REINICIO DE 24 HORAS',
    desc: 'Volvé al control en 24 horas después de un mal día sin culpa ni castigo.',
    value: '$9.000'
  }];
  return <section className="bg-white text-black py-24 px-4 relative overflow-hidden" data-id="element-11">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-brand/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-12"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-brand/5 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-13"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-14">
        <div className="text-center mb-16" data-id="element-15">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-brand text-white rounded-full mb-6 shadow-xl shadow-brand/30" data-id="element-16">
            <Gift className="w-10 h-10" data-id="element-17" />
          </div>
          <h2 className="font-display font-black md:text-5xl mb-4 uppercase text-[32px]" data-id="element-18">
            6 Bonos Estratégicos
          </h2>
          <p className="text-gray-600 font-bold uppercase tracking-widest text-[18px]" data-id="element-19">
            Siempre incluidos con tu combo
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-20">
          {bonuses.map((bono, i) => <div key={i} className="bg-gray-50 border-2 border-gray-100 rounded-2xl p-8 hover:border-brand/30 transition-colors relative group" data-id="element-21">
              <div className="absolute top-0 right-0 bg-black text-white text-xs font-bold px-3 py-1 rounded-bl-lg rounded-tr-xl uppercase tracking-wider" data-id="element-22">
                Bono 0{i + 1}
              </div>
              <h3 className="font-display font-bold text-xl mb-3 pr-12" data-id="element-23">
                {bono.title}
              </h3>
              <p className="text-gray-600 mb-6" data-id="element-24">{bono.desc}</p>
              <div className="flex items-center gap-2 font-bold" data-id="element-25">
                <span className="text-gray-400 line-through" data-id="element-26">
                  Valor: {bono.value}
                </span>
                <span className="text-brand uppercase" data-id="element-27">→ Gratis</span>
              </div>
            </div>)}
        </div>

        <div className="bg-black text-white rounded-2xl p-8 text-center shadow-2xl" data-id="element-28">
          <h3 className="font-display font-black text-2xl md:text-3xl" data-id="element-29">
            Valor total de los bonos:{' '}
            <span className="text-gray-400 line-through" data-id="element-30">$51.000 ARS</span>{' '}
            <span className="text-brand" data-id="element-31">→ GRATIS</span> con tu Super Combo
          </h3>
        </div>
      </div>
    </section>;
}